import { getHolidayDaysInMonth } from "../../utils/holiday-utils";

const monthOptions = [
	{ label: "Janeiro", value: "1" },
	{ label: "Fevereiro", value: "2" },
	{ label: "Março", value: "3" },
	{ label: "Abril", value: "4" },
	{ label: "Maio", value: "5" },
	{ label: "Junho", value: "6" },
	{ label: "Julho", value: "7" },
	{ label: "Agosto", value: "8" },
	{ label: "Setembro", value: "9" },
	{ label: "Outubro", value: "10" },
	{ label: "Novembro", value: "11" },
	{ label: "Dezembro", value: "12" }
];

export const holidayFormConfig = holiday => {
	const year = holiday?.year || new Date().getFullYear();

	const totalDays = getHolidayDaysInMonth(
		holiday?.month,
		year
	);

	const dayOptions = Array.from(
		{ length: totalDays },
		(_, index) => {
			const day = index + 1;

			return {
				label: String(day).padStart(2, "0"),
				value: String(day)
			};
		}
	);

	return [
		{
			fields: [
				{
					name: "name",
					label: "Nome do feriado *",
					type: "text",
					placeholder: "Ex: Tiradentes",
					defaultValue: holiday?.name || "",
					columns: 12
				},
				{
					name: "month",
					label: "Mês *",
					type: "select",
					placeholder: "Selecione",
					options: monthOptions,
					defaultValue: holiday?.month || "",
					columns: 12,
					actions: [
						{
							targetField: "day",
							clearTargetOnChange: true
						}
					]
				},
				{
					name: "day",
					label: "Dia *",
					type: "select",
					placeholder: "Selecione",
					options: dayOptions,
					defaultValue: holiday?.day || "",
					disabled: !holiday?.month,
					columns: 12
				}
			]
		}
	];
};